import api from './api';
import type { PaginatedResponse, ApiResponse } from '@/types/table';

export interface CrudService<T> {
  getAll: (params?: object) => Promise<PaginatedResponse<T>>;
  getById: (id: string) => Promise<ApiResponse<T>>;
  create: (data: Partial<T> | Record<string, unknown>) => Promise<ApiResponse<T>>;
  update: (id: string, data: Partial<T> | Record<string, unknown>) => Promise<ApiResponse<T>>;
  delete: (id: string, params?: object) => Promise<void>;
  exportCsv: (params?: object) => Promise<Blob>;
}

export function createCrudService<T>(route: string): CrudService<T> {
  return {
    getAll: async (params) => {
      const response = await api.get(route, { params });
      return response.data;
    },
    getById: async (id) => {
      const response = await api.get(`${route}/${id}`);
      return response.data;
    },
    create: async (data) => {
      const response = await api.post(route, data);
      return response.data;
    },
    update: async (id, data) => {
      const response = await api.patch(`${route}/${id}`, data);
      return response.data;
    },
    delete: async (id, params) => {
      await api.delete(`${route}/${id}`, { params });
    },
    exportCsv: async (params) => {
      const response = await api.get(`${route}/export/csv`, {
        params,
        responseType: 'blob',
      });
      return response.data;
    },
  };
}

export function createSubResourceGetter<R>(route: string, subResource: string) {
  return async (id: string): Promise<PaginatedResponse<R>> => {
    const response = await api.get(`${route}/${id}/${subResource}`);
    return response.data;
  };
}
